import { pageRoutes } from "constant/routes";

export const handleRedirectToHelpCenter = () =>
  window?.open(pageRoutes.HELP_CENTER);
